import { useAssessCalculation } from "@features/ax/hooks";
import { getConditionLabel } from "@features/ax/utils";
import { logEvent } from "@shared/analytics/analytics";
import { CustomTooltip } from "@shared/components/CustomTooltip";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Tabs } from "@shared/ui/tabs";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ConditionParameterTab } from "./ConditionParameterTab";

export const ConditionsRisksTab: React.FC<{ data: any }> = ({ data }) => {
  const { id } = useParams();
  const remoteUtilityId = useRemoteUtilityId();
  const assessmentName = "asset-assessment";
  const assessCondition = useAssessCalculation(assessmentName, Number(id));

  useEffect(() => {
    logEvent("condition_risk_tab_viewed");
  }, []);
  const handleAssessCondition = () => {
    const payload = {
      isAccessCondition: true,
      entityType: 1,
      entityId: Number(id),
      remoteUtilityId: Number(remoteUtilityId),
    };
    assessCondition.mutateAsync(payload);
  };

  const handleAssessRisk = () => {
    const payload = {
      isAccessRisk: true,
      entityType: 1,
      entityId: Number(id),
      remoteUtilityId: Number(remoteUtilityId),
    };
    assessCondition.mutateAsync(payload);
  };

  // Tab Configuration
  const tabComponents = {
    overview: {
      label: "Condition Parameter",
      component: <ConditionParameterTab data={data} />,
    },
    // history: {
    //   label: "History",
    //   component: <HistoryTab />,
    // },
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <div className="flex gap-2 items-center">
                <CardTitle className="text-xl font-semibold">
                  Asset Condition
                </CardTitle>
                <CustomTooltip
                  message={
                    "A single score representing the overall operational effectiveness of this asset, combining reliability, availability, and efficiency."
                  }
                />
              </div>
              {/* <Button variant="outline" onClick={() => handleAssessCondition()}>
                Assess Condition
              </Button> */}
            </div>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-4 mb-4">
              <div className="text-4xl font-bold text-gray-900">
                {data?.conditionScores ?? "NA"}
              </div>
              <Badge>{getConditionLabel(data?.conditionScores).label}</Badge>
            </div>
            <div className="space-y-2 text-sm text-gray-600">
              <p>Last Assessed: {data?.createdDate || "N/A"}</p>
              <p>Assessed By: {data?.createdUserRemoteName || "N/A"}</p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <div className="flex gap-2 items-center">
                <CardTitle className="text-xl font-semibold">
                  Asset Risk
                </CardTitle>
                <CustomTooltip
                  message={
                    "The overall risk this asset poses, combining its likelihood of failure with the consequences of that failure."
                  }
                />
              </div>

              {/* <Button variant="outline" onClick={() => handleAssessRisk()}>
                Assess Risk
              </Button> */}
            </div>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-4 mb-4">
              <div className="text-4xl font-bold text-gray-900">
                {data?.riskScore || 0}
              </div>
              <Badge>{data?.riskStatus || "N/A"}</Badge>
            </div>
            <div className="space-y-2 text-sm text-gray-600">
              <p>Last Assessed: {data?.createdDate || "N/A"}</p>
              <p>Assessed By: {data?.createdUserRemoteName || "N/A"}</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Tabs */}
      <Tabs
        tabComponents={tabComponents}
        defaultValue="overview"
        urlMapping={{
          overview: "overview",
          history: "history",
        }}
        idPrefix="conditions-risks-tab"
        level={1}
      />
    </div>
  );
};
